export default "__VITE_ASSET__AKQEk1CB__"